module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/kiosk-settings-f74c72b0d4ade8b466c7597178f33a91.svg";